// Hide sticky CTA on AI LP page
const initCloseStickyCta = () => {
  const stickyCtaCloseButton = document.querySelector(
    "[data-sticky-cta-close-button]"
  );
  const stickyCta = document.querySelector("[data-sticky-cta]");
  if (stickyCtaCloseButton && stickyCta) {
    stickyCtaCloseButton.addEventListener("click", () => {
      stickyCta.classList.add("opacity-0", "pe-none");
    });
  }
};

export default initCloseStickyCta;
